define('shared/util/state/adapters/offers',[
    'shared/util/storageWrapper',
    'shared/lib/RSVP'
], function (storageWrapper, rsvp) {
    'use strict';

    var ORDER = 'offers';
    var KEY = 'b2c.session.offers';
    var data;
    var adapter = {
        'init': function(state) {
            return storageWrapper.get(KEY)
                .then(function(value){
                    data = (value != null && typeof value === 'object' ? value : {});
                    if (data !== value) {
                        return storageWrapper.set(KEY, data);
                    }
                    else {
                        return rsvp.resolve();
                    }
                })
                .then(function(){
                    return state.put(ORDER, data);
                });
        },
        'isApplicable' : function (key) {
            return key && (key.split('.')[0] === ORDER);
        },
        'afterPut' : function () {
            return storageWrapper.set(KEY, data);
        }
    };

    return adapter;
});

